import React, { useEffect, useState } from 'react';
import 'react-quill/dist/quill.snow.css';
import Button from '../../components/CustomButtons/Button';
import { IconButton } from '@material-ui/core';
import NotificationAsk from '../../components/Notification/NotificationAsk';
import TemplateBlock from './TemplateBlock';
import Notification from '../../components/Notification/Notification';
import CustomInputValid from '../../components/CustomInput/CustomInputValid';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import { ArrowBack } from '@material-ui/icons';
import { Close } from '@material-ui/icons';
import { Dialog } from '@material-ui/core';
import CustomSelect from '../../components/CustomSelect/CustomSelect';
import { pageBreakHTML, templateBlockTypes, templateTypes } from './TemplatesModel';
import { logoHTML, ownerBrokerHTML } from './TemplatesModel';
import CustomSimpleDialog from '../../components/CustomDialog/CustomSimpleDialog';
import { clone, handleError } from '../../shared/utility';
import TemplatePMAPDFViewer from './TemplatePMAPDFViewer';
import axios from 'store/axios/axios-templates';
import { renderTemplatePDF } from './TemplateLogic';
import Loader from '../../components/Loader/Loader';
import TemplateERTLPDFViewer from './TemplateERTLPDFViewer';
import CustomCheckbox from '../../components/CustomCheckbox/CustomCheckbox';
import TemplateDiff from './TemplateDiff';

function generateRandomCode(length = 5) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
}

function haveObjectsChanged(arr1, arr2) {
  if (arr1.length !== arr2.length) return true;
  for (let i = 0; i < arr1.length; i++) {
    const a = JSON.stringify(arr1[i]);
    const b = JSON.stringify(arr2[i]);
    if (a !== b) return true;
  }
  return false;
}

let blockCounter = 0;
const generateId = () => `block-${generateRandomCode()}-${blockCounter++}`;

function TemplateForm(props) {
  const [showBorder, setShowBorder] = useState('No');
  const [blocks, setBlocks] = useState([]);
  const [blocksBefore, setBlocksBefore] = useState([]);
  const [title, setTitle] = useState('');
  const [status, setStatus] = useState(1);
  const [editingId, setEditingId] = useState(null);
  const [notificationAsk, setNotificationAsk] = useState(null);
  const [notification, setNotification] = useState('');
  const [choose, setChoose] = useState('');
  const [addData, setAddData] = useState(null);
  const [askBeforeDelete, setAskBeforeDelete] = useState(null);
  const [previewPDF, setPreviewPDF] = useState(false);
  const [pdfData, setPDFData] = useState(null);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const [compare, setCompare] = useState('No');

  const addBlock = (afterId, type = 'Default') => {
    setAddData({
        afterId, type
    });
  }

  const addBlockFinal = (afterId = null, type = 'Default', blockToCopy) => {
    const newBlock = {
      id: generateId(),
      type,
      content: '',
      content2: ''
    };
    if (blockToCopy) {
        newBlock.style = blockToCopy.style;
        newBlock.content = blockToCopy.content;
    }
    if (type === 'Logo') {
        newBlock.content = logoHTML;
    }
    if (type === 'Centered Logo') {
        newBlock.content = `<div style="text-align:center">${logoHTML}</div>`;
    }
    if (type === 'Page Break') {
        newBlock.content = pageBreakHTML;
    }
    if (type === 'Owner Broker Columns') {
        newBlock.content = ownerBrokerHTML;
    }
    console.log('adding block', newBlock);
    setBlocks(prev => {
      if (!afterId) return [...prev, newBlock];
      const index = prev.findIndex(b => b.id === afterId);
      const before = prev.slice(0, index + 1);
      const after = prev.slice(index + 1);
      return [...before, newBlock, ...after];
    });
    setEditingId(newBlock.id);
    setChoose('');
    setAddData(null);
  };

  const moveBlock = (id, direction) => {
    const array = clone(blocks);
    const index = array.findIndex(item => item.id === id);
    if (index === -1) return; // id not found
    const targetIndex = direction === 'left' ? index - 1 : index + 1;
    // Bounds check
    if (targetIndex < 0 || targetIndex >= array.length) return;
    // Swap elements
    const newArray = [...array];
    [newArray[index], newArray[targetIndex]] = [newArray[targetIndex], newArray[index]];
    setBlocks(newArray);
    setEditingId(null);
  }

  const removeBlock = (id) => {
    setAskBeforeDelete(id);
  }

  const removeBlockFinal = (id) => {
    setBlocks(prev => prev.filter(b => b.id !== id));
    if (editingId === id) setEditingId(null);
  };

  const handleContentChange = (id, content, style) => {
    if (style) {
        setBlocks(prev => prev.map(b => b.id === id ? { ...b, style } : b));
    } else {
        setBlocks(prev => prev.map(b => b.id === id ? { ...b, content } : b));
    }
  };

  const handleContentChange2 = (id, content2, style) => {
    if (style) {
        setBlocks(prev => prev.map(b => b.id === id ? { ...b, style } : b));
    } else {
        setBlocks(prev => prev.map(b => b.id === id ? { ...b, content2 } : b));
    }
  };

  const renderPDF = async () => {
    try {
        setLoadingPDF(true);
        const response = await axios.post('/generate_pdf', {
            type: props.templateType,
            data: renderTemplatePDF({
                data: {},
                type: props.templateType,
                blocks,
                is_preview_only: true
            }),
            id: '1'
        });
        console.log('response', response.data);
        if (response.data) {
            setPDFData(response.data);
            setPreviewPDF(props.templateType);
        }
        setLoadingPDF(false);
    } catch(e) {
        handleError(e);
        setLoadingPDF(false);
    }
  }

  const validateData = () => {
    let pass = true;
    if (!title) {
        setNotification('Title is required');
        return;
    }
    return pass;
  }

  useEffect(() => {
    if (props.templateEntry) {
        setBlocksBefore(clone(props.templateEntry.json_data));
        setBlocks(props.templateEntry.json_data);
        setTitle(props.templateEntry.title);
        setStatus(props.templateEntry.status);
    }
  }, []);

  console.log('TemplateForm', blocks, title, status, props);
  console.log('TemplatesForm 2', pdfData);

  return (
    <Dialog
            open={true}
            onClose={props.close}
            fullScreen={true}
            fullWidth={true}
            maxWidth={false}
        >
            <div className="dialog-wrapper">
                <div className="top-dweller">
                    <span
                        onClick={() => {
                            // check if changed 
                            if (haveObjectsChanged(blocksBefore, blocks)) {
                                setNotification('Please save your template');
                                return;
                            }
                            props.close();
                        }}
                    >
                        <Close />
                    </span>
                </div>
                <div>
                    <ArrowBack
                        className="hoverable"
                        onClick={() => {
                            props.close();
                        }}
                    />
                    
                    <div className="space-y-4">
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={4}>
                                <CustomInputValid 
                                    value={title}
                                    onChange={(e) => {
                                        setTitle(e.target.value);
                                    }}
                                    label="Title"
                                />
                                {!title && <div className="red-text">Required</div>}
                            </GridItem>
                            <GridItem xs={12} sm={12} md={4}>
                                <CustomSelect 
                                    options={[{ id: 1, desc: 'Inactive'}, { id:2, desc: 'Active'}]}
                                    default={status}
                                    choose={(chosen) => {
                                        setStatus(chosen);
                                    }}
                                    label="Choose Status"
                                    indx="id"
                                    desc="desc"
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={4}>
                                
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <h3>{props.templateEntry.id ? 
                                    `${props.templateType} Template #${props.templateEntry.id}` 
                                    : 
                                    `New ${props.templateType} Template`}</h3>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={4}>
                                
                            </GridItem>
                            <GridItem xs={12} sm={12} md={4}>
                                
                            </GridItem>
                            <GridItem xs={12} sm={12} md={4}></GridItem>
                        </GridContainer>
                    
                    
                    <div className={`template-box ql-editor ${showBorder === 'Yes' ? '' : 'no-bordery'}`}
                        style={{marginBottom: 100}}
                    >
                        {blocks.map(block => {
                            return <React.Fragment key={block.id}>
                                {<TemplateBlock 
                                    block={block}
                                    editingId={editingId} 
                                    setEditingId={setEditingId}
                                    handleContentChange={handleContentChange}
                                    handleContentChange2={handleContentChange2} 
                                    removeBlock={removeBlock}
                                    moveBlock={moveBlock}
                                    addBlock={addBlock}
                                    key={block.id}
                                    templateType={props.templateType}
                                    duplicateBlock={(blockToCopy) => {
                                        addBlockFinal(null, null, blockToCopy);
                                    }}
                                />}
                                {compare === 'Yes' && <TemplateDiff 
                                    block={block}
                                    default_entry={props.default_entry}
                                />}
                            </React.Fragment>
                        })}
                    </div>

                    {addData && <CustomSimpleDialog 
                        no_ok_button={true}
                        open={true}
                        close={() => {
                            setAddData(null);
                        }}
                        content={<>
                            <h4>CHOOSE A BLOCK</h4>
                            <CustomSelect 
                                options={Object.keys(templateBlockTypes).map(tbt => {
                                    return templateBlockTypes[tbt] 
                                })}
                                default={choose}
                                choose={(chosen) => {
                                    setChoose(chosen);
                                }}
                                label="Choose Block Type"
                            />
                            <Button color="success"
                                className="mr-20"
                                onClick={() => {
                                    if (!choose) return;
                                    addBlockFinal(addData.afterId, choose);
                                    setAddData(null);
                                }}
                            >
                                ADD
                            </Button>
                            <Button color="white"
                                onClick={() => {
                                    setAddData(null);
                                }}
                            >
                                CANCEL
                            </Button>
                        </>}
                    />}

                    {askBeforeDelete && <NotificationAsk 
                        open={true}
                        close={() => {
                            setAskBeforeDelete(null);
                        }}
                        success={() => {
                            removeBlockFinal(askBeforeDelete);
                            setAskBeforeDelete(null);
                        }}
                        title="Are you sure?"
                        message="Do you want to delete this block?"
                    />}

                    {notification && <Notification 
                        open={true}
                        close={() => {
                            setNotification('');
                        }}
                        message={notification}
                    />}

                    <div className="bottom-dweller">
                            <IconButton
                                style={{marginRight:20}}
                                onClick={() => addBlock(null, choose)}
                            >
                                <i className="fa fa-plus-circle text-blue-600" />
                            </IconButton>
                            <Button
                                color="primary"
                                className="mr-20"
                                onClick={async () => {
                                    if (props.templateEntry.id) {
                                        // UPDATE
                                        const pass = validateData();
                                        if (!pass) return;
                                        console.log('blocks', blocks);
                                        const passed = await props.updateTemplate({
                                            id: props.templateEntry.id,
                                            json_data: JSON.stringify(blocks),
                                            title,
                                            status,
                                            type: props.templateType
                                        });
                                        if (passed) props.setNotification('Saved');
                                        setBlocksBefore(clone(blocks));
                                        props.loadTemplates();
                                    } else {
                                        // CREATE 
                                        const pass = validateData();
                                        if (!pass) return;
                                        console.log('blocks', blocks);
                                        props.createTemplate({
                                            json_data: JSON.stringify(blocks),
                                            title,
                                            status: 1,
                                            type: props.templateType
                                        });
                                        props.close();
                                    }
                                }}
                            ><i className="fa fa-save"></i> {props.templateEntry.id ? 'SAVE' : 'CREATE NEW'}</Button>

                            <Button color="white"
                                onClick={() => {
                                    if (!loadingPDF) renderPDF();
                                }}
                                className="mr-20"
                            >
                                {loadingPDF ? <Loader /> : 'PREVIEW PDF'}
                            </Button>

                            {props.templateEntry.id && <Button color="rose"
                                className="mr-20"
                                onClick={() => {
                                    // SAVE CURRENT 
                                    const pass = validateData();
                                    if (!pass) return;
                                    console.log('blocks', blocks);
                                    props.duplicate({
                                        json_data: JSON.stringify(blocks),
                                        title: title + ' (COPY)',
                                        status: 1,
                                        type: props.templateType
                                    });
                                }}
                            >
                                DUPLICATE
                            </Button>}

                            
                            <GridContainer>
                                <GridItem xs={12} sm={6} md={6}>
                                    <CustomCheckbox 
                                        checked={showBorder === 'Yes' ? true : false}
                                        onChange={() => {
                                            if (showBorder === 'Yes') setShowBorder('No');
                                            if (showBorder === 'No') setShowBorder('Yes');
                                        }}
                                        label="Show Block Borders"
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={6} md={6}>
                                    <CustomCheckbox 
                                        checked={compare === 'Yes' ? true : false}
                                        onChange={() => {
                                            if (compare === 'Yes') setCompare('No');
                                            if (compare === 'No') setCompare('Yes');
                                        }}
                                        label="Compare Differences"
                                    />
                                </GridItem>
                            </GridContainer>
                    </div>
                </div>

                    {previewPDF === 'PMA' && pdfData && <TemplatePMAPDFViewer 
                        open={true}
                        close={() => {
                            setPreviewPDF(false);
                            setPDFData(null);
                        }}
                        pdfData={pdfData}
                    />}

                    {previewPDF === 'ERTL' && pdfData && <TemplateERTLPDFViewer
                        open={true}
                        close={() => {
                            setPreviewPDF(false);
                            setPDFData(null);
                        }}
                        pdfData={pdfData}
                    />}

            </div>
        </div>
    </Dialog>
  );
}

export default TemplateForm;
